import React, { useEffect, useRef, useState } from 'react';
import styles from './css/index.module.scss';
import SearchIcon from '../../../../assets/icons/searchBlue.svg';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import Loading from '../../../../ui-kit/Loading';
import QuestionHint, { QUESTION_HINT_POSITIONS } from '../../../../components/QuestionHint';

const SEARCH_DEBOUNCE_MS = 500;

function ListSearch({ onSearch, loading = false, hintText }) {
  const { t } = useTranslations();
  const [value, setValue] = useState('');
  const isFirstRender = useRef(true);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }

    const timer = setTimeout(() => {
      onSearchRef.current(value);
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <label className={styles.search}>
      {loading ? (
        <span className={styles.spinner}>
          <Loading height={14} width={14} color="#081B4D" />
        </span>
      ) : (
        <img className={styles.icon} src={SearchIcon} alt="" />
      )}
      <input
        className={styles.input}
        type="text"
        value={value}
        placeholder={`${t(DICTIONARY.search)}...`}
        onChange={(ev) => setValue(ev.target.value)}
      />
      {hintText ? (
        // preventDefault: a click on the hint must not focus the input (the label would do it; on mobile it opens the keyboard).
        <span className={styles.hint} onClick={(ev) => ev.preventDefault()}>
          <QuestionHint text={hintText} position={QUESTION_HINT_POSITIONS.bottomLeft} />
        </span>
      ) : null}
    </label>
  );
}

export default ListSearch;
